export default __webpack_public_path__ + "static/media/open-group-icon.d770c344.svg";